import type { CSSProperties } from 'react';
import { Text } from './Text';

interface TextFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  maxLength?: number;
  minHeight?: string;
  style?: CSSProperties;
}

function TextField({
  value,
  onChange,
  placeholder,
  disabled = false,
  maxLength,
  minHeight = '120px',
  style
}: TextFieldProps) {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    let newValue = e.target.value;
    if (maxLength) {
      newValue = newValue.slice(0, maxLength);
    }
    onChange(newValue);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        border: 'var(--card-border-stroke) var(--card-border-style) var(--card-border-color)',
        borderRadius: 'var(--card-border-radius)',
        padding: '8px',
        backgroundColor: '#ffffff',
        opacity: disabled ? 0.6 : 1,
        ...style
      }}
    >
      <textarea
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
        style={{
          padding: 0,
          fontSize: '14px',
          border: 'none',
          outline: 'none',
          fontFamily: 'inherit',
          resize: 'none',
          minHeight,
          backgroundColor: 'transparent',
          cursor: disabled ? 'not-allowed' : 'text',
          width: '100%'
        }}
      />
      {maxLength && (
        <Text
          variant='body2'
          style={{
            color: 'var(--text-secondary)',
            textAlign: 'right'
          }}
        >
          {value.length}/{maxLength}
        </Text>
      )}
    </div>
  );
}

export default TextField;
